import { render, staticRenderFns } from "./FilterPresets.vue?vue&type=template&id=bd807ca4&"
import script from "./FilterPresets.vue?vue&type=script&lang=js&"
export * from "./FilterPresets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports